import { render, staticRenderFns } from "./CreateTeamStudentsDialog.vue?vue&type=template&id=280ba5be&scoped=true"
import script from "./CreateTeamStudentsDialog.vue?vue&type=script&lang=js"
export * from "./CreateTeamStudentsDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateTeamStudentsDialog.vue?vue&type=style&index=0&id=280ba5be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280ba5be",
  null
  
)

export default component.exports